// Copyright 2016 Sorama B.V.

import { Unit, UnitType } from "units/Unit";

export class Length extends UnitType {
    public static override typeName = "Length";

    public static milliMeter: Unit = new Unit("mm", 1e-3, Length, { aliases: ["millimeter", "millimeters"] });
    public static centiMeter: Unit = new Unit("cm", 1e-2, Length, { aliases: ["centimeter", "centimeters"] });
    public static deciMeter: Unit = new Unit("dm", 1e-1, Length, { aliases: ["decimeter", "decimeters"] });
    public static meter: Unit = new Unit("m", 1, Length, { aliases: ["meter", "meters"] });
    public static kiloMeter: Unit = new Unit("km", 1e3, Length, { aliases: ["kilometer", "kilometers"] });

    public static inch: Unit = new Unit("in", 0.0254, Length, { aliases: ["inch", "inches"] });
    public static feet: Unit = new Unit("ft", 0.3048, Length, { aliases: ["foot"] });
    public static yard: Unit = new Unit("yd", 0.9144, Length, { aliases: ["yard", "yards"] });
    public static mile: Unit = new Unit("mi", 1609.344, Length, { aliases: ["mile", "miles"] });
}
